module.exports = __webpack_public_path__ + "img/2.a30e721f.webp";